import React, { useState } from 'react';

import { Dialog, LegacyText, Button, styled } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

export const TitleText = styled(LegacyText)`
  font-size: 16px;
  letter-spacing: 0.15px;
  padding-bottom: 16px;
`;
export const BodyText = styled(LegacyText)`
  font-size: 16px;
  letter-spacing: 0.25px;
`;

export const MobileApplicationAvailable = ({ onClose, onExited, open }) => {
  const onGoMobile = () => {
    window.location.href = process.env.REACT_APP_MOBILE_HOST;
  };
  return (
    <Dialog
      open={open}
      onExited={onExited}
      onClose={onClose}
      disableEscapeKeyDown={true}
      fullWidth={true}
      fullScreen={false}
      maxWidth={'sm'}
    >
      <Dialog.Content>
        <TitleText variant={'body2'}>
          Accessing GoGame from your mobile?
        </TitleText>
        <BodyText variant={'body2'}>
          Switch to GoGame mobile webapp to have the best experience on mobile
        </BodyText>
      </Dialog.Content>
      <Dialog.Actions>
        <Button color={'primary'} onClick={onClose}>
          NO THANKS
        </Button>
        <Button color={'primary'} onClick={onGoMobile}>
          GO TO MOBILE APP
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

const isTouchDevice = 'ontouchstart' in document.documentElement;
const isAllowEnvMobile = !!process.env.REACT_APP_MOBILE_HOST;
const isShowMobileMode = isAllowEnvMobile && isTouchDevice;

const mobileViewPort =
  'viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=0.1, maximum-scale=1.0, user-scalable=no';
const webViewPort = 'width=device-width, initial-scale=0.01';

if (isShowMobileMode) {
  const viewportMeta = document.querySelector('meta[name=viewport]');
  viewportMeta.setAttribute('content', mobileViewPort);
}

export const MobileApplicationChecker = ({ children }) => {
  const [showMobile, setShowMobile] = useState(isShowMobileMode);

  const [childComponent] = useChildComponent(MobileApplicationAvailable, {
    onSubmit: () => {
      const viewportmeta = document.querySelector('meta[name=viewport]');
      viewportmeta.setAttribute('content', webViewPort);
      setShowMobile(false);
    },
    onClose: () => {
      const viewportmeta = document.querySelector('meta[name=viewport]');
      viewportmeta.setAttribute('content', webViewPort);
      setShowMobile(false);
    },
  });

  if (showMobile) {
    return childComponent;
  }

  return children;
};
